import { useState } from "react";

export default function Section18() {
  const faqs = [
    {
      question: "How long does it take to develop a website?",
      answer:
        "Most projects take 6 -16 weeks, depending on features, integrations, and complexity. We provide clear timelines before starting.",
    },
    {
      question: "Do you build Shopify apps?",
      answer:
        "Yes. Mean3 specializes in building Shopify apps and integrations that extend store functionality and improve performance.",
    },
    {
      question: "Are your websites SEO-optimized?",
      answer:
        "Every website we build is optimized for SEO, including speed, mobile-friendliness, and content.",
    },
    {
      question: "Do you offer post-launch support?",
      answer:
        "Yes. We provide ongoing maintenance, updates, and performance monitoring to keep your website secure and running smoothly.",
    },
    {
      question: "What industries do you work with?",
      answer:
        "We work across ecommerce, SaaS, healthcare, real estate, tech startups, retail, and more, tailoring solutions to each industry’s needs.",
    },
    {
      question: "How much does developing a website cost?",
      answer:
        "Costs vary depending on size, features, and complexity. Mean3 offers transparent pricing with flexible packages to suit startups and enterprises.",
    },
    {
      question: "Does Mean3 handle platform migrations?",
      answer:
        "We provide seamless migrations from Magento, WooCommerce, BigCommerce, or custom CMS to Shopify Plus or modern frameworks, with zero downtime.",
    },
  ];

  const [isOpen, setIsOpen] = useState(new Array(faqs.length).fill(false));

  const handleFaq = (index) => {
    setIsOpen((prevState) =>
      prevState.map((item, idx) => (idx === index ? !item : false))
    );
  };

  return (
    <div className="w-full SectionWebsiteFAQs mt-[8%] md:mt-[-4%]">
      <div className="w-full section-container">
        <div className="w-[90%] md:w-[61%] pb-[1%] mx-auto text-center">
          <h2 className="leading-[29px] md:leading-[41px] text-[24px] md:text-[30px] text-[#151515] font-bold my-[0.67em]">
            Frequently Asked Questions about Website Development
          </h2>
        </div>

        <div className="w-full md:w-[784px] p-5 md:p-[2%] mx-auto faq-container font-open leading-[21px]">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="faq-item text-[11px] md:text-sm rounded-[8px] p-[2%] border border-solid border-[#DEDEDE] mb-[4%]"
              // style={{
              //   background:
              //     "linear-gradient(0deg, #FEFFFF, #FEFFFF), linear-gradient(0deg, #DEDEDE, #DEDEDE)",
              // }}
            >
              <div
                onClick={() => handleFaq(index)}
                className="question text-[#444444] cursor-pointer flex justify-between items-center"
              >
                {faq.question}
                <b className="text-[40px] text-[#DA2128] font-[300]">
                  {isOpen[index] ? "-" : "+"}
                </b>
              </div>
              <div className={`${isOpen[index] ? "block" : "hidden"} answer text-[#444444]`}>
                <br />
                <p className="mb-5">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Button */}
        <div className="text-center mt-8">
          <a
            href="https://mean3.com/contact-mean3"  // replace with your desired link if different
            className="bg-[#DA2128] hover:bg-[#b71c22] text-white px-8 py-3 rounded-lg font-semibold text-[15px] md:text-[16px] transition-all duration-300 inline-block text-center"
          >
            Ask Your Question
          </a>

        </div>
      </div>

      {/* Divider Line */}
      <div className="line mb-[55px] md:mb-[4%] mt-[1%] mx-auto w-[70%] md:w-[61%] shadow-line h-2 rounded-[100%]"></div>
    </div>
  );
}
